module.exports = __webpack_public_path__ + "img/c5.9cf1ef18.png";